module.exports = __webpack_public_path__ + "static/media/aquarider-10222_01.9e2e11be.png";